<template>
  <v-container>
    <v-form ref="form" v-model="valid" @submit.prevent="verificarDataParcelas">
      <v-list class="pa-0" two-line>
        <v-toolbar height="56" color="primary">
          <v-toolbar-title class="subheading white--text">
            Infos. Gerais
          </v-toolbar-title>
        </v-toolbar>

        <v-card class="pa-2" v-show="showHeaderEndossos">
          <v-layout row wrap>
            <v-flex>
              <v-btn
                class="button-custom"
                :disabled="botaoEndosso"
                @click="rotaGridEndosso"
                flat
              >
                ENDOSSOS
              </v-btn>
              <v-btn
                class="button-vinculo"
                @click="showModalVinculoGrupos = true"
                flat
              >
                VINCULAR GRUPOS
              </v-btn>
              <BotaoRecusarCotacao :idApolice="idApolice" :idPropostaStatus="idPropostaStatus" variant="toolbar" />
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 sm12 md3 pr-2 text-xs-left>
              <v-card
                style="border: 1px solid #BABABA; border-radius: 5px;"
                flat
              >
                <v-card-text style="padding: 5px 10px; margin: 0;">
                  <b
                    >Cotação Auto-Frota
                    {{ retirarNull(apoliceNumeroCotacao) }}</b
                  >
                  <br />
                  <v-layout align-center>
                    <v-flex
                      xs7
                      style="padding-top: -5px; margin-top: -5px;"
                    ></v-flex>
                    <v-flex
                      text-xs-right
                      xs5
                      style="padding-top: -15px; margin-top: -5px; padding: 0px; margin: 0px;"
                    >
                      <v-tooltip bottom color="blue darken-1">
                        <v-btn
                          style="padding: -20px 0px 0px 0px; margin: -10px 0px 0px 0px;"
                          slot="activator"
                          icon
                          color="transparent"
                          @click="dialogDownloadCotacao = true"
                        >
                          <v-icon text-xs-right color="#00456e">get_app</v-icon>
                        </v-btn>
                        <div style="text-align: center;">Download</div>
                      </v-tooltip>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12 sm12 md3 pr-2 text-xs-left>
              <v-card
                style="border: 1px solid #BABABA; border-radius: 5px;"
                flat
              >
                <v-card-text style="padding: 5px 10px; margin: 0;">
                  <b
                    >Proposta Auto-Frota
                    {{ retirarNull(apoliceNumeroProposta) }}</b
                  >
                  <br />
                  <v-layout align-center>
                    <v-flex
                      xs7
                      style="padding-top: -5px; margin-top: -5px;"
                    ></v-flex>
                    <v-flex
                      text-xs-right
                      xs5
                      style="padding-top: -15px; margin-top: -5px; padding: 0px; margin: 0px;"
                    >
                      <v-tooltip bottom color="blue darken-1">
                        <v-btn
                          :disabled="desabilitaBotoes"
                          style="padding: -20px 0px 0px 0px; margin: -10px 0px 0px 0px;"
                          slot="activator"
                          icon
                          color="transparent"
                          @click="dialogDownloadProposta = true"
                        >
                          <v-icon text-xs-right color="#00456e">get_app</v-icon>
                        </v-btn>
                        <div style="text-align: center;">Download</div>
                      </v-tooltip>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>

            <v-flex xs12 sm12 md3 pr-2 text-xs-left>
              <v-card
                style="border: 1px solid #BABABA; border-radius: 5px;"
                flat
              >
                <v-card-text style="padding: 5px 10px; margin: 0;">
                  <b>Apólice Auto-Frota {{ retirarNull(apoliceNumero) }}</b>
                  <br />
                  <v-layout align-center>
                    <v-flex
                      xs7
                      style="padding-top: -5px; margin-top: -5px;"
                    ></v-flex>
                    <v-flex
                      text-xs-right
                      xs5
                      style="padding-top: -15px; margin-top: -5px; padding: 0px; margin: 0px;"
                    >
                      <v-tooltip bottom color="blue darken-1">
                        <v-btn
                          :disabled="desabilitaBotoesApolice"
                          style="padding: -20px 0px 0px 0px; margin: -10px 0px 0px 0px;"
                          slot="activator"
                          icon
                          color="transparent"
                          @click.native="gerarApolice"
                        >
                          <v-icon text-xs-right color="#00456e">get_app</v-icon>
                        </v-btn>
                        <div style="text-align: center;">Download</div>
                      </v-tooltip>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>

            <v-flex xs12 sm12 md3 pr-2 text-xs-left>
              <v-card
                style="border: 1px solid #BABABA; border-radius: 5px;"
                flat
              >
                <v-card-text style="padding: 5px 10px; margin: 0;">
                  <b
                    >Boleto Auto-Frota
                    {{ retirarNull(apoliceNumeroProposta) }}</b
                  >
                  <br />
                  <v-layout align-center>
                    <v-flex xs7 style="padding-top: -5px; margin-top: -5px;">
                    </v-flex>
                    <v-flex
                      text-xs-right
                      xs5
                      style="padding-top: -15px; margin-top: -5px; padding: 0px; margin: 0px;"
                    >
                      <v-tooltip bottom color="blue darken-1">
                        <v-btn
                          :disabled="desabilitaBotoes"
                          style="padding: -20px 0px 0px 0px; margin: -10px 0px 0px 0px;"
                          slot="activator"
                          icon
                          color="transparent"
                          @click.native="gerarBoleto"
                        >
                          <v-icon text-xs-right color="#00456e">get_app</v-icon>
                        </v-btn>
                        <div style="text-align: center;">Download</div>
                      </v-tooltip>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card>

        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-card class="pa-5">
          <v-flex class="py-4"> Histórico da Proposta </v-flex>
          <v-layout v-if="desabilitaBotaoSalvar" row wrap pb-5>
            <v-flex xs12 sm5 md5>
              <v-autocomplete
                v-model="campoUsuarioReponsavel"
                item-text="nome"
                item-value="id"
                :items="listaUsuariosResponsavel"
                label="Corretor responsável"
                :rules="regras.notSelected"
                :disabled="camposDisabled"
              >
                <template v-slot:selection="data">
                  {{ data.item.nome }}
                </template>
                <template v-slot:no-data>
                  <div class="px-4">
                    Nenhum usuário encontrado com esse nome.
                  </div>
                </template>
                <template v-slot:item="data">
                  <v-list-tile-content
                    @click="usuarioResponsavelSet(data.item.id, data.item.nome)"
                  >
                    <v-list-tile-title
                      v-html="data.item.nome"
                    ></v-list-tile-title>
                    <v-list-tile-sub-title
                      v-html="data.item.email"
                    ></v-list-tile-sub-title>
                  </v-list-tile-content>
                </template>
              </v-autocomplete>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md5 >
              <v-autocomplete
                v-model="campoTecnicoResponsavel"
                item-text="nome"
                item-value="id"
                :items="listaTecnicoResponsavel"
                label="Tecnico Responsável"
                :disabled="camposDisabled"
                :rules="regras.notSelected"
              >
                <template v-slot:selection="data">
                  {{ data.item.nome }}
                </template>
                <template v-slot:no-data>
                  <div class="px-4">
                    Nenhum técnico responsavel encontrado com esse nome.
                  </div>
                </template>
                <template v-slot:item="data">
                  <v-list-tile-content
                    @click="tecnicoResponsavelSet(data.item.id, data.item.nome)"
                  >
                    <v-list-tile-title
                      v-html="data.item.nome"
                    ></v-list-tile-title>
                    <v-list-tile-sub-title
                      v-html="data.item.email"
                    ></v-list-tile-sub-title>
                  </v-list-tile-content>
                </template>
              </v-autocomplete>
            </v-flex>
          </v-layout>
          <v-layout v-if="!desabilitaBotaoSalvar" row wrap pb-5>
            <v-flex xs12 sm5 md5>
              <v-autocomplete
                v-model="campoUsuarioReponsavel"
                item-text="nome"
                item-value="id"
                :items="listaUsuariosResponsavel"
                label="Corretor responsável"
                :rules="regras.notSelected"
                :disabled="camposDisabled"
              >
                <template v-slot:selection="data">
                  {{ data.item.nome }}
                </template>
                <template v-slot:no-data>
                  <div class="px-4">
                    Nenhum usuário encontrado com esse nome.
                  </div>
                </template>
                <template v-slot:item="data">
                  <v-list-tile-content
                    @click="salvarCorretorResponsavel(data.item.id, data.item.nome)"
                  >
                    <v-list-tile-title
                      v-html="data.item.nome"
                    ></v-list-tile-title>
                    <v-list-tile-sub-title
                      v-html="data.item.email"
                    ></v-list-tile-sub-title>
                  </v-list-tile-content>
                </template>
              </v-autocomplete>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md5>
              <v-autocomplete
                v-model="campoTecnicoResponsavel"
                item-text="nome"
                item-value="id"
                :items="listaTecnicoResponsavel"
                label="Tecnico Responsável da Apólice"
                :rules="regras.notSelected"
                :disabled="camposDisabled"
              >
                <template v-slot:selection="data">
                  {{ data.item.nome }}
                </template>
                <template v-slot:no-data>
                  <div class="px-4">
                    Nenhum técnico responsável encontrado com esse nome.
                  </div>
                </template>
                <template v-slot:item="data">
                  <v-list-tile-content
                    @click="salvarTecnicoResponsavel(data.item.id, data.item.nome)"
                  >
                    <v-list-tile-title
                      v-html="data.item.nome"
                    ></v-list-tile-title>
                    <v-list-tile-sub-title
                      v-html="data.item.email"
                    ></v-list-tile-sub-title>
                  </v-list-tile-content>
                </template>
              </v-autocomplete>
            </v-flex>
          </v-layout>
          <v-spacer></v-spacer>
          <v-layout row wrap>
            <v-flex xs12 sm5 md2>
              <v-select
                label="Tipo"
                :items="propostaTipoList"
                v-model="idPropostaTipo"
                item-text="titulo"
                item-value="id"
                required
                :rules="regras.notNull"
                :disabled="camposDisabled"
              >
              </v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-select
                label="Tipo Seguro"
                :items="apoliceTipoDePropostaList"
                v-model="idTipoDeProposta"
                item-text="titulo"
                item-value="id"
                required
                :rules="regras.notNull"
                :disabled="camposDisabled"
              >
              </v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-select
                disabled
                label="Status"
                :items="propostaStatusList"
                v-model="idPropostaStatus"
                item-text="titulo"
                item-value="id"
              >
              </v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm12 md3>
              <v-menu
                ref="menu"
                v-model="menu3"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                disabled
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="textInicio"
                    label="Data da Ultima Atualização"
                    prepend-icon="event"
                    readonly
                    disabled
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="dateInicio" no-title scrollable>
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
          </v-layout>
        </v-card>
        <v-card class="pa-5">
          <v-flex class="py-4"> Proponente </v-flex>
          <v-layout row wrap pb-4>
            <v-flex xs12 sm4 md2>
              <v-text-field
                label="Razão Social"
                required
                browser-autocomplete="off"
                :rules="regras.notNull"
                v-model="proponenteRazaoSocial"
                :disabled="camposDisabled"
              >
              </v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-select
                label="Tipo Pessoa"
                item-text="titulo"
                item-value="id"
                v-model="idTipoPessoa"
                :items="tipoPessoaList"
                required
                :rules="regras.notNull"
                :disabled="camposDisabled"
              >
              </v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex md2>
              <v-text-field
                :mask="
                  this.idTipoPessoa === 1
                    ? '###.###.###-##'
                    : 'NN.NNN.NNN/NNNN-##'
                "
                :label="{ 1: 'CPF', 2: 'CNPJ' }[idTipoPessoa] || 'CPF/CNPJ'"
                browser-autocomplete="off"
                required
                :rules="regrasCnpjCpf"
                v-model="proponenteCnpj"
                :disabled="!idTipoPessoa || camposDisabled"
                @blur="verificarBloqueioCnpjCpf"
              >
              </v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm4 md2>
              <v-text-field
                mask="##.###-###"
                label="CEP Pernoite"
                required
                browser-autocomplete="off"
                v-model="cepPernoite"
                :rules="[...regras.notNull, ...regras.cep]"
                :disabled="camposDisabled"
              >
              </v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
          </v-layout>
          <v-layout v-show="idTipoPessoa==1" row wrap pb-4>
            <v-flex xs12 sm4 md2>

                <v-radio-group :disabled="camposDisabled"  row label="Possui Nome Social" v-model="informarNomeSocial" >
                <div class="wrapper-radio-social">
                  <v-radio
                    label="Sim"
                    :value="true"
                  ></v-radio>
                  <v-radio
                    label="Não"
                    :value="false"
                  ></v-radio>
                </div>
              </v-radio-group>
            </v-flex>
            <v-flex xs12 sm4 md2 style="align-items:center">
              <v-text-field
                label="Nome Social"
                :rules="informarNomeSocial ? regras.nomeSocial : []"
                v-model="nomeSocial"
                :disabled="!informarNomeSocial || camposDisabled"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 sm4 md2>

            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 sm12 md6>
              <v-select
                :items="proponenteRamoDeAtuacaoList"
                v-model="idProponenteRamoDeAtuacao"
                label="Ramo de Atuação"
                item-text="titulo"
                item-value="id"
                required
                :rules="regras.notNull"
                :disabled="camposDisabled"
              >
              </v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex md3 xs6>
              <v-btn
                block
                :disabled="desabilitarHistoricoSinistros"
                @click="buscarHistoricoSinistro"
                color="primary"
              >
                HISTÓRICO DE SINISTROS
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
        <v-card class="pa-5">
          <v-flex class="py-4"> Endereço </v-flex>
          <v-layout row wrap pb-4>
            <v-flex xs12 sm4 md2>
              <v-text-field
                mask="##.###-###"
                label="CEP"
                required
                browser-autocomplete="off"
                v-model="enderecoCep"
                :rules="[...regras.notNull, ...regras.cep]"
                :disabled="camposDisabled"
              >
              </v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm4 md3>
              <v-text-field
                label="Rua"
                browser-autocomplete="off"
                required
                v-model="enderecoRua"
                :rules="regras.notNull"
                :disabled="camposDisabled"
              >
              </v-text-field>
            </v-flex>

            <v-spacer></v-spacer>
            <v-flex xs12 sm2 md1>
              <v-text-field
                label="Número"
                browser-autocomplete="off"
                riquered
                :rules="regras.notNull"
                v-model="enderecoNumero"
                :disabled="camposDisabled"
              >
              </v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm2 md1>
              <v-text-field
                label="Complemento"
                browser-autocomplete="off"
                riquered
                :rules="regras.notNull"
                v-model="enderecoComplemento"
                :disabled="camposDisabled"
              >
              </v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm2 md3>
              <v-text-field
                label="Bairro"
                browser-autocomplete="off"
                riquered
                :rules="regras.notNull"
                v-model="enderecoBairro"
                :disabled="camposDisabled"
              >
              </v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm2 md3>
              <v-text-field
                label="Cidade"
                browser-autocomplete="off"
                riquered
                :rules="formRulesComputed.endereco.cidade(enderecoCidade, true)"
                v-model="enderecoCidade"
                :disabled="camposDisabled"
              >
              </v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm2 md1>
              <v-select
                label="UF"
                browser-autocomplete="off"
                riquered
                item-text="titulo"
                item-value="id"
                :items="enderecoUfList"
                v-model="idEnderecoUf"
                :rules="regras.notNull"
                :disabled="camposDisabled"
              >
              </v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-flex xs12 sm2 md2>
              <v-text-field
                mask="(##) #####-####"
                label="Telefone (com DDD)"
                browser-autocomplete="off"
                riquered
                :rules="
                  formRulesComputed.telefone.numero(enderecoTelefone, true)
                "
                v-model="enderecoTelefone"
                :disabled="camposDisabled"
              >
              </v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm2 md3>
              <v-text-field
                label="Email"
                browser-autocomplete="off"
                riquered
                :rules="[...regras.notNull, ...regras.email]"
                v-model="enderecoEmail"
                :disabled="camposDisabled"
              >
              </v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
          </v-layout>
        </v-card>
        <v-card class="pa-5">
          <v-flex class="py-4"> Apólice</v-flex>
          <v-layout row wrap pb-4>
            <v-flex xs12 sm2 md2>
              <v-text-field
                disabled
                v-model="apoliceNumeroCotacao"
                label="N. da Cotação"
                required
              >
              </v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex
              xs12
              sm2
              md2
              v-if="
                apoliceNumeroProposta === null ||
                  apoliceNumeroProposta === 'null'
              "
            >
              <v-text-field disabled label="N. da Proposta"> </v-text-field>
            </v-flex>
            <v-flex xs12 sm2 md2 v-else>
              <v-text-field
                disabled
                v-model="apoliceNumeroProposta"
                label="N. da Proposta"
              >
              </v-text-field>
            </v-flex>

            <v-spacer></v-spacer>
            <v-flex
              xs12
              sm2
              md2
              v-if="apoliceNumero === 'null' || apoliceNumero === null"
            >
              <v-text-field disabled label="N. da Apolice" required>
              </v-text-field>
            </v-flex>

            <v-flex xs12 sm2 md2 v-else>
              <v-text-field
                disabled
                v-model="apoliceNumero"
                label="N. da Apolice"
                required
              >
              </v-text-field>
            </v-flex>
            <v-spacer></v-spacer>

            <v-flex xs12 sm4 md2>
              <v-menu
                ref="menu"
                v-model="menu1"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="textInicio"
                    label="Inicio da Vigência"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                    required
                    :disabled="camposDisabled"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dateInicio"
                  @change="onDateChange"
                  no-title
                  scrollable
                >
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm4 md3>
              <v-menu
                ref="menu"
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="textFim"
                    label="Fim da Vigência"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                    required
                    :disabled="camposDisabled"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="dateFim" no-title scrollable>
                </v-date-picker>
              </v-menu>
            </v-flex>

            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 sm2 md1>
              <v-text-field
                label="Qtd. de Itens"
                required
                v-model="quantidadeItens"
                :rules="regrasQuantidadeItens"
                disabled
              >
              </v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm3 md3>
              <v-select
                :items="apoliceModalidadeList"
                label="Modalidade"
                v-model="idApoliceModalidade"
                item-text="titulo"
                item-value="id"
                required
                :rules="regras.notNull"
                :disabled="camposDisabled"
              >
              </v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-flex xs12 sm2 md1>
              <v-text-field
                type="number"
                v-model="apoliceIof"
                label="IOF (%)"
                required
                :rules="regras.notNull"
                :disabled="camposDisabled"
              >
              </v-text-field>
            </v-flex>
            <v-spacer></v-spacer>

            <v-spacer></v-spacer>
            <v-flex xs12 sm2 md2>
              <v-text-field
                type="number"
                label="Perc. de Sinistros"
                v-model="apolicePercSinistro"
                required
                :rules="regras.notNull"
                :disabled="camposDisabled"
              >
              </v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 sm3 md3>
              <v-text-field
                type="number"
                v-model="gatilhoEstipulado"
                label="Gatilho Estipulado (%)"
                required
                :rules="habilitarCampoGatilhos ? [] : regras.notNull"
                :disabled="habilitarCampoGatilhos"
                suffix="%"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 sm3 md3 class="px-3">
              <v-text-field
                type="number"
                v-model="sinistralidadePermissivel"
                label="Sinistralidade Permissível (%)"
                required
                suffix="%"
                :rules="habilitarCampoGatilhos ? [] : regras.notNull"
                :disabled="habilitarCampoGatilhos"
              >
              </v-text-field>
            </v-flex>
          </v-layout>
        </v-card>
        <v-card class="pa-5">
          <v-flex class="py-4"> Valores </v-flex>
          <v-layout row wrap>
            <v-flex xs12 sm3 md2>
              <v-text-field
                type="number"
                label="Comissão (%)"
                v-model="corretagem"
                required
                :rules="regras.notNull"
                :disabled="camposDisabled"
              >
              </v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm3 md2>
              <v-text-field
                disabled
                label="Prêmio Total (R$)"
                v-model="totalPremio"
                required
              >
              </v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex>
              <v-btn
                class="button-custom"
                @click="dialogParticipantes = true"
                flat
              >
                participantes
              </v-btn>
            </v-flex>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
          </v-layout>
          <v-spacer></v-spacer>
          <v-layout row wrap>
            <v-flex xs12 sm4 md2>
              <v-menu
                ref="menu"
                v-model="menu4"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="textPrimeiraParcela"
                    label="Data da Primeira Parcela"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                    required
                    :disabled="camposDisabled"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dataPrimeiraParcela"
                  no-title
                  scrollable
                >
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm3 md1>
              <v-select
                label="Qtd. de parcelas"
                :items="parcelamentoList"
                v-model="idParcelamento"
                item-text="titulo"
                item-value="id"
                required
                :rules="regras.notNull"
                :disabled="camposDisabled"
              >
              </v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm7 md3>
              <v-select
                :items="formaPagamentoList"
                v-model="idFormaPagamento"
                label="Forma de Pagamento"
                item-text="titulo"
                item-value="id"
                required
                :rules="regras.notNull"
                :disabled="camposDisabled"
              >
              </v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
          </v-layout>
        </v-card>
      </v-list>
      <v-layout pt-5 align-center>
        <v-spacer></v-spacer>
        <BotaoRecusarCotacao :idApolice="idApolice" :idPropostaStatus="idPropostaStatus" variant="footer" class="mr-3" />
        <v-btn color="primary" @click="voltar" outline class="mr-3"> Voltar </v-btn>
        <v-btn class="button-custom" type="submit" flat :disabled="cnpjBloqueado"> Próximo</v-btn>
      </v-layout>
    </v-form>
    <v-snackbar
      :timeout="3000"
      :color="snackbar.sucesso ? 'success' : 'error'"
      multi-line
      v-model="snackbar.visivel"
    >
      {{ snackbar.mensagem }}
      <v-btn dark flat @click.native="snackbar.visivel = false">Fechar</v-btn>
    </v-snackbar>

    <template>
      <v-layout row justify-center>
        <v-dialog persistent v-model="dialogParticipantes" max-width="1200px">
          <ModalParticipantes
            v-if="dialogParticipantes"
            :dialog="dialogParticipantes"
            @fechar="dialogParticipantes = false"
            @salvar="salvarParticipantes"
            :participantes="participanteList"
            :somenteLeitura="camposDisabled"
          />
        </v-dialog>
      </v-layout>
    </template>
    <template>
      <v-dialog width="1300" persistent v-model="dialogHistorioSinistro">
        <ModalHistorioSinistro
          @fecharModalHistoricoSinistro="fecharModalDialogSinistro"
          :listagemHistoricoSinistro="listagemHistoricoSinistro"
          :listagemFrequencia="listagemFrequencia"
        ></ModalHistorioSinistro>
      </v-dialog>
    </template>
    <template>
      <v-dialog width="20%" persistent v-model="dialogDownloadCotacao">
        <v-card>
          <v-card-title class="primary">
            <span class="headline">Download da cotação</span>
          </v-card-title>
          <v-card-text>
            <v-flex>
              <a
                class="btn-download-pdf"
                style="justify-content: center;"
                @click="gerarCotacaoComPremioLiquido"
              >
                <v-icon text-xs-right color="#027DB4">get_app</v-icon>
                <span>PDF com informações de prêmio líquido</span>
              </a>
            </v-flex>
            <v-flex class="mt-2">
              <v-icon text-xs-right color="#027DB4">get_app</v-icon>
              <a
                class="btn-download-pdf"
                style="justify-content: center;"
                @click="gerarCotacaoSemPremioLiquido"
              >
                <span>PDF sem informações de prêmio líquido</span>
              </a>
            </v-flex>
          </v-card-text>
          <v-card-actions>
            <v-layout>
              <v-flex style="display: flex; justify-content: flex-end">
                <v-btn
                  color="primary"
                  flat
                  @click="dialogDownloadCotacao = false"
                >
                  FECHAR
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog width="20%" persistent v-model="dialogDownloadProposta">
        <v-card>
          <v-card-title class="primary">
            <span class="headline">Download da proposta</span>
          </v-card-title>
          <v-card-text>
            <v-flex>
              <a
                class="btn-download-pdf"
                style="justify-content: center;"
                @click="gerarPropostaComPremioLiquido"
              >
                <v-icon text-xs-right color="#027DB4">get_app</v-icon>
                <span>PDF com informações de prêmio líquido</span>
              </a>
            </v-flex>
            <v-flex class="mt-2">
              <v-icon text-xs-right color="#027DB4">get_app</v-icon>
              <a
                class="btn-download-pdf"
                style="justify-content: center;"
                @click="gerarPropostaSemPremioLiquido"
              >
                <span>PDF sem informações de prêmio líquido</span>
              </a>
            </v-flex>
          </v-card-text>
          <v-card-actions>
            <v-layout>
              <v-flex style="display: flex; justify-content: flex-end">
                <v-btn
                  color="primary"
                  flat
                  @click="dialogDownloadProposta = false"
                >
                  FECHAR
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog
        persistent
        v-model="loaderPagina"
        width="500"
        content-class="elevation-0"
      >
        <v-card>
          <v-container style="background-color: #FFF;height: 100px;">
            <v-layout
              row
              wrap
              class="fill-height"
              align-content="center"
              justify="center"
            >
              <v-flex md12 class="text-subtitle-1 text-center">
                <p
                  style="font-weight: bold; margin-bottom: 0; text-align: center"
                >
                  Processando, aguarde...
                </p>
              </v-flex>
              <v-flex md12>
                <v-progress-linear
                  :indeterminate="true"
                  color="primary"
                  height="6"
                  value="15"
                ></v-progress-linear>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog persistent v-model="mostrarDialogRestricaoTecnica" max-width="570px">
        <ModalRestricaoTecnica
          :mostrarMensagemCompleta = "false"
          @fecharDialogModalRestricaoTecnica="
            mostrarDialogRestricaoTecnica = false;
            $emit('fecharDialogModalRestricaoTecnica');
          ">
        </ModalRestricaoTecnica>
      </v-dialog>
    </template>
    <template>
      <v-dialog persistent v-model="mostrarBloqueioCnpj" max-width="600px">
        <ModalBloqueioCnpjCpf
          :motivo="motivoBloqueioCnpj"
          @fechar="mostrarBloqueioCnpj = false">
        </ModalBloqueioCnpjCpf>
      </v-dialog>
    </template>
    <template>
      <v-dialog>
        <ModalVinculoGrupoUsuarios
          v-if="this.idApolice"
          v-model="showModalVinculoGrupos"
          :id-apolice="this.idApolice"
          :idsSelecionadosInicial="gruposIds"
          @salvo="atualizarGrupos"
        />
      </v-dialog>
    </template>
  </v-container>
</template>
<script>
import axios from "axios";
import usuarioHelper from "@/helpers/usuario-logado.js";
import formRules from "@/helpers/form-rules.js";
import CustomFormat from "@/helpers/custom-format";
import { adicionarId } from "@/helpers/url-helper.js";
import moment from "moment";
import ModalParticipantes from "./ModalParticipantes.vue";
import ModalHistorioSinistro from "./ModalHistorioSinistro.vue";
import tipoPessoEnum from "@/helpers/tipo-pessoa-enum.js";
import ModalRestricaoTecnica from "../corretor-reserva/ModalRestricaoTecnica.vue";
import ModalBloqueioCnpjCpf from "../corretor-reserva/ModalBloqueioCnpjCpf.vue";
import ModalVinculoGrupoUsuarios from "./ModalVinculoGrupoUsuarios.vue";
import BotaoRecusarCotacao from "./BotaoRecusarCotacao.vue";
import validadores from "@/helpers/validadores";

export default {
  name: "InfoGerais",

  components: {
    ModalParticipantes,
    ModalHistorioSinistro,
    ModalRestricaoTecnica,
    ModalBloqueioCnpjCpf,
    ModalVinculoGrupoUsuarios,
    BotaoRecusarCotacao
  },

  data: () => ({
    gruposIds: [],
    showModalVinculoGrupos: false,
    statusAtualApolice: null,
    nomeSocial: null,
    informarNomeSocial: false,
    listagemFrequencia: [],
    gatilhoEstipulado: null,
    sinistralidadePermissivel: null,
    listagemHistoricoSinistro: [],
    loaderPagina: false,
    clickHistoricoSinistro: false,
    dialogHistorioSinistro: false,
    dialogDownloadCotacao: false,
    dialogDownloadProposta: false,
    premioLiquido: null,
    usuarioApisul: null,
    isLoadingUsuarios: false,
    searchUsuarios: null,
    liberarEscolhaUsuarioResponsavel: false,
    idUsuarioCorretorFiltrado: null,
    idTecnicoResponsavelFiltrado: null,
    objetoUsuarioEncontrado: null,
    campoUsuarioReponsavel: null,
    campoTecnicoResponsavel: null,
    listaUsuariosResponsavel: [],
    idUsuarioCorretor: null,
    nomeUsuarioCorretor: null,
    listaTecnicoResponsavel: [],
    idTecnicoResponsavel: null,
    nomeTecnicoResponsavel: null,
    alert: false,
    valid: false,
    botaoEndosso: true,
    dataRespostaApolice: null,
    dataRespostaBoleto: null,
    propostaStatusList: [],
    propostaTipoList: [],
    apoliceModalidadeList: [],
    parcelamentoList: [],
    formaPagamentoList: [],
    idTipoPessoa: null,
    proponenteRamoDeAtuacaoList: [],
    enderecoUfList: [],
    idPropostaStatus: 1,
    idPropostaTipo: null,
    tipoPessoaList: [],
    idTipoDeProposta: null,
    apoliceTipoDePropostaList: [],
    idApoliceModalidade: null,
    idApolice: null,
    dataPrimeiraParcela: new Date().toISOString().slice(0, 10),
    idParcelamento: null,
    idFormaPagamento: null,
    proponenteRazaoSocial: null,
    proponenteCnpj: null,
    cepPernoite: null,
    idProponenteRamoDeAtuacao: null,
    enderecoCep: null,
    enderecoRua: null,
    enderecoNumero: null,
    enderecoComplemento: null,
    enderecoBairro: null,
    enderecoCidade: null,
    idEnderecoUf: null,
    enderecoTelefone: null,
    enderecoEmail: null,
    aplicCondicao: null,
    idAplicaCondicao: null,
    apoliceNumeroProposta: null,
    apoliceNumero: null,
    apoliceNumeroCotacao: null,
    apoliceIof: 7.38,
    apolicePercSinistro: null,
    corretagem: null,
    totalPremio: 0,
    valoresQtdParcelas: null,
    idTipoCondicao: null,
    percentualCondicao: null,
    desabilitaBotoes: false,
    desabilitaBotoesApolice: true,
    desabilitaBotaoSalvar: true,
    modelCorretorResponsavel: {
      idUsuarioCorretor: null,
      nomeUsuarioCorretor: null,
    },
    modelTecnicoResponsavel: {
      idTecnicoResponsavel: null,
      nomeTecnicoResponsavel: null,
    },
    dateAtualizacao: new Date().toISOString().slice(0, 10),
    dateInicio: new Date().toISOString().slice(0, 10),
    dateFim: new Date(
      new Date().getFullYear() + 1,
      new Date().getMonth(),
      new Date().getDate()
    )
      .toISOString()
      .slice(0, 10),
    menu1: false,
    menu2: false,
    menu3: false,
    menu4: false,
    modal: false,
    dialogParticipantes: false,
    tipoCondicaoList: [
      { id: 1, titulo: "Nenhuma" },
      { id: 2, titulo: "Agravo" },
      { id: 3, titulo: " Desconto" }
    ],
    tipoCondicaoFiltrada: [
      { id: 2, titulo: "Agravo" },
      { id: 3, titulo: " Desconto" }
    ],
    aplicCondicaoList: [
      { id: 1, titulo: "Em Todas as coberturas" },
      { id: 2, titulo: "Apenas RCF" },
      { id: 3, titulo: "Apenas Compreensiva" }
    ],
    aplicaCondicaoList: [
      { id: 1, titulo: "Em Todas as coberturas" },
      { id: 2, titulo: "Apenas RCF" },
      { id: 4, titulo: "Nenhuma" }
    ],
    participanteList: [
      {
        idTipoPessoa: 2,
        razaoSocial: "Aphicor Corretora e Administradora de Seguros Ltda.",
        cnpjCpf: "34833592000144",
        enderecoEmail: "seguros@aphicor.com.br",
        enderecoTelefone: "5121219000",
        numeroSusep: "202047257",
        idTipoCoCorretagem: 1,
        coCorretagem: 17,
        corretorLider: true
      }
    ],
    snackbar: {
      visivel: false,
      sucesso: false,
      mensagem: ""
    },
    regras: {
      minItemCategoriaSelected: [v => v !== null && v.length > 0 || 'Selecione uma Categoria'],
      notNull: [v => !!v || "Você não pode deixar este campo em branco"],
      validarNumero: [v => {
        const notNull = !!v || "Você não pode deixar este campo em branco";
        const numeroValido = !isNaN(v) || "Por favor, insira um valor válido";
        return notNull === true ? numeroValido : notNull;
      }],
      notSelected: [v => !!v || "Você não pode deixar este campo em branco"],

      cnpj: [v => !!String(v).match(/^[A-Za-z0-9]{12}\d{2}$/) || "Valor incorreto"],
      cep: [v => !!String(v).match(/^\d{8}$/) || "CEP incorreto"],
      email: [
        v =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "E-mail inválido"
      ],
      nomeSocial: [
        v => !!v || "Você não pode deixar este campo em branco",
        v => (v && v.length >= 5) || "Nome social deve ter no mínimo 5 caracteres",
        v => (v && v.length <= 150) || "Nome social deve ter no máximo 150 caracteres"
      ]
    },
    modelosListas: {
      catVeiculoList: [],
    },
    mostrarDialogRestricaoTecnica: false,
    mostrarBloqueioCnpj: false,
    motivoBloqueioCnpj: null,
    cnpjBloqueado: false,
    mostrarCamposCondicaoComercialEspecial: false,
    listaCondicaoComercialEspecial: [],
    listaCondicaoComercialEspecialModificacao: [],
  }),

  async mounted() {
    this.$store.commit("startLoading");
    this.idApolice = this.$route.query.id;
    this.buscaOpcoesTipoVeiculo();

    if (
      this.$route.query.apoliceCopiada == "true" &&
      this.$route.query.apoliceCopiada != null
    ) {
      this.retornaApoliceCopiada();
    } else if (
      this.$route.query.apoliceRenovacao == "true" &&
      this.$route.query.apoliceRenovacao != null
    ) {
      this.retornaApoliceRenovacao();
      this.idPropostaTipo = 3;
    } else {
      if (this.idApolice) {
        await this.buscarApolice(this.$route.query.id);
        this.apoliceNumeroCotacao = this.formatarNumeroCotacao(this.idApolice);
      }
    }

    this.buscarUsuariosCampoResponsavel(true);
    this.buscarCampoTecnicosResponsaveis(true);
    Object.entries(this.$store.getters["formCotacao/infoGerais"]).forEach(
      ([key, value]) => {
        if (
          (this[key] instanceof Array &&
            value instanceof Array &&
            !this[key].length) ||
          value != null
        ) {
          this[key] = value;
        }
      }
    );
    if (this.$route.query.id) {
      this.verificarExisteCorretorReserva(this.$route.query.id);
    }
    if (this.idUsuarioCorretor) {
      this.campoUsuarioReponsavel = this.idUsuarioCorretor;
    }

    this.$store.commit("endLoading");
    if (
      !this.$route.query.apoliceCopiada &&
      !this.$route.query.apoliceRenovacao &&
      !this.$route.query.id
    ) {
      if (!this.$store.getters["formCotacao/conteudoPlanilhaValido"]) {
        return this.$router.push("/GridPrincipal");
      }
    }
    this.buscaOpcoes();
    this.tipoPessoa();
    if ((this.idApolice = this.$route.query.id)) {
      this.retornarTipoDeProposta();
      if (!this.$route.query.apoliceRenovacao) {
        this.retornarTipo();
      }

      this.retornarTipoPessoa();
      this.retornarAplicaCondicao();
      this.retornarTipoCondicao();
    }
    this.botoesDisabled();
    this.botoesDisabledApolice();
    this.disabledBotaoEndosso();
    this.disabledBotaoSalvar();
    this.buscarListaApoliceCondicaoEspecial();
    this.buscarListaApoliceGrupoUsuario();
  },

  computed: {
    regrasCnpjCpf() {
      if (this.idTipoPessoa === 1) {
        return [
          v => !!v || "Você não pode deixar este campo em branco",
          v => !!String(v).match(/^\d{11}$/) || "CPF inválido"
        ];
      }
      return [
        v => !!v || "Você não pode deixar este campo em branco",
        v => validadores.validarCNPJ(v) || "CNPJ inválido"
      ];
    },
    habilitarCampoGatilhos() {
      if (this.idApoliceModalidade != null && this.idApoliceModalidade == 1) {
        this.sinistralidadePermissivel = null;
        this.gatilhoEstipulado = null;
      }
      if (this.idPropostaStatus > 1 && this.idPropostaStatus < 6) {
        return true;
      } else if (this.idPropostaStatus == 7) {
        return true;
      }
      return this.idApoliceModalidade != null && this.idApoliceModalidade == 1;
    },
    desabilitarHistoricoSinistros() {
      if (this.proponenteCnpj) {
        if (this.idTipoPessoa == tipoPessoEnum.tipoPessoa.FISICA) {
          if (this.proponenteCnpj.length == 11) {
            return false;
          }
        } else if (this.idTipoPessoa == tipoPessoEnum.tipoPessoa.JURIDICA) {
          if (this.proponenteCnpj.length == 14) {
            return false;
          }
        }
      }

      return true;
    },
    showHeaderEndossos() {
      if (
        this.$route.query.apoliceRenovacao ||
        this.$route.query.apoliceCopiada
      ) {
        return false;
      } else if (this.idApolice) {
        return true;
      }
    },
    quantidadeItens() {
      return this.$store.getters["formCotacao/quantidadeItem"];
    },
    copiaParcialSemItens() {
      return this.$store.getters["formCotacao/copiaParcialSemItens"];
    },
    regrasQuantidadeItens() {
      return this.copiaParcialSemItens ? [] : this.regras.notNull;
    },
    percCondicaoComercial: {
      get() {
        switch (this.idTipoCondicao) {
          case 1:
            return 0;
          case 2:
            return +this.percentualCondicao;
          case 3:
            return -this.percentualCondicao;
        }
      },
      set(perc) {
        if (typeof perc === "number") {
          if (perc === 0) {
            this.idTipoCondicao = this.tipoCondicaoList[0].id;
          } else {
            this.percentualCondicao = Math.abs(perc);
            this.idTipoCondicao = this.tipoCondicaoList[perc > 0 ? 1 : 2].id;
          }
        }
      }
    },
    camposDisabled() {
      if (this.idPropostaStatus > 1 && this.idPropostaStatus < 6) {
        return true;
      } else if (this.idPropostaStatus == 7) {
        return true;
      }
    },

    textAtualizacao() {
      return new Date(this.dateAtualizacao).toLocaleDateString("pt-BR", {
        timeZone: "UTC",
        year: "numeric",
        month: "long",
        day: "numeric"
      });
    },
    textInicio() {
      return new Date(this.dateInicio).toLocaleDateString("pt-BR", {
        timeZone: "UTC",
        year: "numeric",
        month: "long",
        day: "numeric"
      });
    },
    textFim() {
      return new Date(this.dateFim).toLocaleDateString("pt-BR", {
        timeZone: "UTC",
        year: "numeric",
        month: "long",
        day: "numeric"
      });
    },
    textPrimeiraParcela() {
      return new Date(this.dataPrimeiraParcela).toLocaleDateString("pt-BR", {
        timeZone: "UTC",
        year: "numeric",
        month: "long",
        day: "numeric"
      });
    },
    formRulesComputed: function() {
      return formRules;
    }
  },
  watch: {
    listaCondicaoComercialEspecial(newVal) {
      if (newVal && newVal.length > 0) {
        this.idTipoCondicao = 1;
        this.percentualCondicao = null;
      }
    },
    idTipoCondicao(newVal) {
      if (newVal == 1) {
        this.idAplicaCondicao = 4;
        this.percentualCondicao = 0;
      } else {
        this.idTipoCondicao = newVal;
      }
    },
    idTipoPessoa: function() {

      this.$refs.form.resetValidation()
    },
    informarNomeSocial: function() {

      this.$refs.form.resetValidation()
    }
  },
  methods: {
    atualizarGrupos(ids) {
      this.gruposIds = ids;
    },
    tratamentoErrorBuscaHistorico() {
      this.dialogHistorioSinistro = false;
      this.snackbar.visivel = true;
      this.snackbar.sucesso = false;
      this.snackbar.mensagem =
        "Erro ao buscar historico de sinistro deste cpf/cnpj";
    },
    abrirModalHistoricoSinistro() {
      this.clickHistoricoSinistro = !this.clickHistoricoSinistro;
      this.dialogHistorioSinistro = true;
    },
    async retornaApoliceCopiada() {
      const response = await axios.get(
        `${process.env.URL_APOLICEMS}/v1/retornarCopiaApolice/${this.idApolice}`,
        {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
      );
      if (response.data.idUsuarioCorretor) {
        this.buscarUsuarioId(response.data.idUsuarioCorretor);
      }

      if (response.data.idTecnicoResponsavel) {
        this.buscarTecnicoResponsavelId(response.data.idTecnicoResponsavel);
      }

      this.idUsuarioCorretorFiltrado = response.data.idUsuarioCorretor;
      this.idTecnicoResponsavelFiltrado = response.data.idTecnicoResponsavel;

      const mutationDadosApolice = this.$store.getters["formCotacao/copiaParcial"]
        ? "formCotacao/setDadosApoliceCopiaParcial"
        : "formCotacao/setDadosApolice";

      this.$store.commit(
        mutationDadosApolice,
        typeof response.data === "string"
          ? JSON.parse(response.data)
          : response.data
      );

      Object.entries(response.data).forEach(([key, value]) => {
        if (
          (this[key] instanceof Array &&
            value instanceof Array &&
            !this[key].length) ||
          value != null
        ) {
          this[key] = value;
        }
      });
      this.idProponenteRamoDeAtuacao = response.data.proponenteRamoDeAtuacao.id;
      this.idParcelamento = response.data.parcelamento.id;
      this.idApoliceModalidade = response.data.apoliceModalidade.id;

      if (response.data.idUsuarioCorretor) {
        this.buscarUsuarioId(response.data.idUsuarioCorretor);
      }
      if (response.data.idTecnicoResponsavel) {
        this.buscarTecnicoResponsavelId(response.data.idTecnicoResponsavel);
      }

      this.idUsuarioCorretorFiltrado = response.data.idUsuarioCorretor;
      this.idTecnicoResponsavelFiltrado = response.data.idTecnicoResponsavel;
      this.idEnderecoUf = response.data.enderecoUf.id;
      this.idFormaPagamento = response.data.formaPagamento.id;
    },

    async retornaApoliceRenovacao() {
      const res = await axios.get(
        `${process.env.URL_APOLICEMS}/v1/retornarApoliceRenovacao/${this.idApolice}`,
        {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
      );
      this.$store.commit(
        "formCotacao/setDadosApoliceReduzido",
        typeof res.data === "string" ? JSON.parse(res.data) : res.data
      );
      Object.entries(res.data).forEach(([key, value]) => {
        if (
          (this[key] instanceof Array &&
            value instanceof Array &&
            !this[key].length) ||
          value != null
        ) {
          this[key] = value;
        }
      });
      this.idProponenteRamoDeAtuacao = res.data.proponenteRamoDeAtuacao.id;
      this.idParcelamento = res.data.parcelamento.id;
      this.idApoliceModalidade = res.data.apoliceModalidade.id;
      if (res.data.idUsuarioCorretor) {
        this.buscarUsuarioId(res.data.idUsuarioCorretor);
      }

      if (res.data.idTecnicoResponsavel) {
        this.buscarTecnicoResponsavelId(res.data.idTecnicoResponsavel);
      }
      this.idUsuarioCorretorFiltrado = res.data.idUsuarioCorretor;
      this.idTecnicoResponsavelFiltrado = res.data.idTecnicoResponsavel;
      this.idEnderecoUf = res.data.enderecoUf.id;
      this.idFormaPagamento = res.data.formaPagamento.id;
    },
    verificarExisteCorretorReserva(idApolice) {
      axios
        .get(
          `${process.env.URL_CORRETORMS}/v1/verificarCorretorApoliceExiste/${idApolice}`,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        )
        .catch(err => {
          this.snackbar.visivel = true;
          this.snackbar.sucesso = false;
          this.snackbar.mensagem = err.response.data.message;
        });
    },
    tratamentoCampoUsuarioResponsavel(idUsuario, response) {
      if (idUsuario != null) {
        if (idUsuario == 0) {
          this.usuarioApisul = {
            id: 0,
            nome: "GRUPO APISUL",
            email: "grupo@apisul.com"
          };
        } else {
          this.listaUsuariosResponsavel = response;
          this.buscarUsuarioId(idUsuario);
        }
      }
    },
    tratamentoCampoTecnicoResponsavel(idTecnicoResponsavel, response) {
      if (idTecnicoResponsavel != null) {
        if (idTecnicoResponsavel == 0) {
          this.usuarioApisul = {
            id: 0,
            nome: "GRUPO APISUL",
            email: "grupo@apisul.com"
          };
        } else {
          this.listaTecnicoResponsavel = response;
          this.buscarTecnicoResponsavelId(idTecnicoResponsavel);
        }
      }
    },
    buscarUsuarioId(id) {
      axios
        .get(
          `${process.env.URL_USUARIOMS}/v1/no-auth/buscaUsuarioSimplesPorId?id=${id}`,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        )
        .then(response => {
          if (response) {
            this.listaUsuariosResponsavel.push(response.data);
            this.campoUsuarioReponsavel = id;
          }
        })
        .catch(err => {
          this.snackbar.visivel = true;
          this.snackbar.sucesso = false;
          this.snackbar.mensagem = err.response.data.message;
        });
    },
    buscarTecnicoResponsavelId(id) {
      axios
        .get(
          `${process.env.URL_USUARIOMS}/v1/no-auth/buscarTecnicoResponsavelPorId?idTecnicoResponsavel=${id}`,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        )
        .then(response => {
          if (response) {
            this.listaTecnicoResponsavel.push(response.data);
            this.campoTecnicoResponsavel = id;
          }
        })
        .catch(err => {
          this.snackbar.visivel = true;
          this.snackbar.sucesso = false;
          this.snackbar.mensagem = err.response.data.message;
        });
    },
    usuarioResponsavelSet(id, nome) {
      if (id && nome) {
        this.idUsuarioCorretorFiltrado = id;
        this.idUsuarioCorretor = id;
        this.nomeUsuarioCorretor = nome;
      }
    },
    tecnicoResponsavelSet(id, nome) {
      if (id && nome) {
        this.idTecnicoResponsavelFiltrado = id;
        this.idTecnicoResponsavel = id;
        this.nomeTecnicoResponsavel = nome;
      }
    },
    buscarUsuariosCampoResponsavel(tratamentoBuscar) {
      axios
        .get(`${process.env.URL_APOLICEMS}/v1/buscarUsuariosApolice`, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        })
        .then(response => {
          if (response) {
            if (
              this.campoUsuarioReponsavel &&
              tratamentoBuscar &&
              this.idUsuarioCorretor
            ) {
              this.tratamentoCampoUsuarioResponsavel(
                this.campoUsuarioReponsavel,
                response.data
              );
            } else if (
              this.idApolice != undefined &&
              this.idApolice != null &&
              tratamentoBuscar &&
              this.idUsuarioCorretorFiltrado
            ) {
              this.tratamentoCampoUsuarioResponsavel(
                this.idUsuarioCorretorFiltrado,
                response.data
              );
            } else {
              this.listaUsuariosResponsavel = response.data;
            }
          }
        })
        .catch(err => {
          this.snackbar.visivel = true;
          this.snackbar.sucesso = false;
          this.snackbar.mensagem = err.response.data.message;
        });
    },
    buscarCampoTecnicosResponsaveis(tratamentoBuscar) {
      axios
        .get(`${process.env.URL_APOLICEMS}/v1/buscarTecnicosResponsaveisApolice`, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        })
        .then(response => {
          if (response) {
            if (
              this.campoTecnicoResponsavel &&
              tratamentoBuscar &&
              this.idTecnicoResponsavel
            ) {
              this.tratamentoCampoTecnicoResponsavel(
                this.campoTecnicoResponsavel,
                response.data
              );
            } else if (
              this.idApolice != undefined &&
              this.idApolice != null &&
              tratamentoBuscar &&
              this.idTecnicoResponsavelFiltrado
            ) {
              this.tratamentoCampoTecnicoResponsavel(
                this.idTecnicoResponsavelFiltrado,
                response.data
              );
            } else {
              this.listaTecnicoResponsavel = response.data;
            }
          }
        })
        .catch(err => {
          this.snackbar.visivel = true;
          this.snackbar.sucesso = false;
          this.snackbar.mensagem = err.response.data.message;
        });
    },
    verificarDataParcelas() {
      if (!this.$refs.form.validate()) {
        return;
      }
      axios
        .get(
          `${process.env.URL_APOLICEMS}/v1/validarDataParcelamento?dataFimPolice=${this.dateFim}&dataInicioParcela=${this.dataPrimeiraParcela}&parcelas=${this.idParcelamento}`,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        )
        .then(response => {
          if (response) {
            this.proximaPagina();
          }
        })
        .catch(err => {
          this.snackbar.visivel = true;
          this.snackbar.sucesso = false;
          this.snackbar.mensagem = err.response.data.message
            ? err.response.data.message
            : "Não é possível avançar para próxima página";
        });
    },

    verificarListaSuja() {
      axios
        .get(`${process.env.URL_ESSORMS}/v1/restricao-tecnica?cpfCnpj=${this.proponenteCnpj}&tipoPessoa=${this.idTipoPessoa}`, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        })
        .then(response => {
          if (response.data.estaRestrito === true) {
            this.mostrarDialogRestricaoTecnica = true;
          } else {
            if (this.$refs.form.validate() || this.idPropostaStatus == 4) {
              this.$store.commit("formCotacao/setInfoGerais", {
                idPropostaStatus: this.idPropostaStatus,
                idPropostaTipo: this.idPropostaTipo,
                idTipoDeProposta: this.idTipoDeProposta,
                idApoliceModalidade: this.idApoliceModalidade,
                idFormaPagamento: this.idFormaPagamento,
                idParcelamento: this.idParcelamento,
                proponenteRazaoSocial: this.proponenteRazaoSocial,
                proponenteCnpj: this.proponenteCnpj,
                cepPernoite: this.cepPernoite,
                idProponenteRamoDeAtuacao: this.idProponenteRamoDeAtuacao,
                enderecoCep: this.enderecoCep,
                enderecoRua: this.enderecoRua,
                enderecoNumero: this.enderecoNumero,
                enderecoComplemento: this.enderecoComplemento,
                enderecoBairro: this.enderecoBairro,
                idEnderecoUf: this.idEnderecoUf,
                enderecoCidade: this.enderecoCidade,
                enderecoTelefone: this.enderecoTelefone,
                enderecoEmail: this.enderecoEmail,
                apoliceIof: this.apoliceIof,
                apolicePercSinistro: this.apolicePercSinistro,
                corretagem: this.corretagem,
                totalPremio: this.totalPremio,
                idTipoPessoa: this.idTipoPessoa,
                dataPrimeiraParcela: this.dataPrimeiraParcela,
                dateInicio: this.dateInicio,
                dateFim: this.dateFim,
                participanteList: this.participanteList,
                percCondicaoComercial: this.percCondicaoComercial,
                idAplicaCondicao:
                  this.idAplicaCondicao === null || this.idAplicaCondicao == undefined
                    ? 4
                    : this.idAplicaCondicao,
                idTipoCondicao: this.idTipoCondicao,
                idUsuarioCorretor: this.idUsuarioCorretorFiltrado,
                nomeUsuarioCorretor: this.nomeUsuarioCorretor,
                gatilhoEstipulado:
                  this.gatilhoEstipulado == null ? "" : this.gatilhoEstipulado,
                sinistralidadePermissivel:
                  this.sinistralidadePermissivel == null
                    ? ""
                    : this.sinistralidadePermissivel,
                nomeSocial: !this.informarNomeSocial ? "" : this.nomeSocial,
                informarNomeSocial: this.informarNomeSocial,
                idTecnicoResponsavel: this.idTecnicoResponsavelFiltrado,
                nomeTecnicoResponsavel: this.nomeTecnicoResponsavel,
                listaCondicaoComercialEspecial: this.listaCondicaoComercialEspecial,
                listaCondicaoComercialEspecialModificacao: this.listaCondicaoComercialEspecialModificacao
              });
              if (this.$route.query.apoliceCopiada == "true") {
                this.$router.push(
                  `/GridPrincipal/Risco?id=${this.idApolice}&apoliceCopiada=${true}${this.statusAtualApolice ? `&idPropostaStatus=${this.statusAtualApolice}` : ''}`
                );
              } else if (this.$route.query.apoliceRenovacao == "true") {
                this.$router.push(
                  `/GridPrincipal/Risco?id=${this.idApolice}&apoliceRenovacao=${true}${this.statusAtualApolice ? `&idPropostaStatus=${this.statusAtualApolice}` : ''}`
                );
              } else {
                this.$router.push(
                  `/GridPrincipal/Risco${this.idApolice ? `?id=${this.idApolice}` : ''}${this.statusAtualApolice ? `&idPropostaStatus=${this.statusAtualApolice}` : ''}`
                );
              }
            }
          }
        })
        .catch(err => {
          console.error("Ocorreu um erro ao verificar a lista suja: ", err);
        });
    },

    salvarParticipantes(participanteList) {
      this.participanteList = participanteList;
      this.dialogParticipantes = false;
    },

    rotaGridEndosso() {
      return this.$router.push(
        "/GridPrincipal/InfoGerais/GridEndossos?id=" + this.idApolice +"&idPropostaStatus=" + this.idPropostaStatus
      );
    },
    botoesDisabled() {
      if (this.idPropostaStatus == 3 || this.idPropostaStatus == 4) {
        return (this.desabilitaBotoes = false);
      } else {
        return (this.desabilitaBotoes = true);
      }
    },
    botoesDisabledApolice() {
      if (
        this.apoliceNumero != null &&
        !this.apoliceNumero.includes("null") &&
        this.idPropostaStatus == 4
      ) {
        this.desabilitaBotoesApolice = false;
      } else {
        this.desabilitaBotoesApolice = true;
      }
    },
    disabledBotaoSalvar() {
      if (
        this.apoliceNumeroCotacao != null &&
        !this.apoliceNumeroCotacao.includes("null")
      ) {
        this.desabilitaBotaoSalvar = false;
      } else {
        this.desabilitaBotaoSalvar = true;
      }
    },
    disabledBotaoEndosso() {
      if (((this.apoliceNumero != null && this.apoliceNumero != "null") && this.idPropostaStatus === 4) || this.idPropostaStatus == 7 || this.idPropostaStatus == 12) {
        this.botaoEndosso = false;
      } else {
        this.botaoEndosso = true;
      }
    },
    retirarNull(numero) {
      if (numero === null || numero === "null" || numero === undefined) {
        return;
      } else return numero;
    },

    preencherCampoTipoCondicao() {
      if (this.percentualCondicao > 0) {
        this.idTipoCondicao = 2;
      } else if (this.percentualCondicao == null) {
        this.idTipoCondicao = 1;
      } else if (this.percentualCondicao < 0) {
        this.idTipoCondicao = 3;
      }
    },

    gerarCotacaoComPremioLiquido() {
      this.premioLiquido = true;
      this.gerarCotacao();
    },

    gerarCotacaoSemPremioLiquido() {
      this.premioLiquido = false;
      this.gerarCotacao();
    },

    gerarPropostaComPremioLiquido() {
      this.premioLiquido = true;
      this.gerarProposta();
    },

    gerarPropostaSemPremioLiquido() {
      this.premioLiquido = false;
      this.gerarProposta();
    },

    gerarCotacao() {
      return axios({
        url:
          `${process.env.URL_APOLICEMS}/v1/gerarProposta/` +
          this.idApolice +
          `?tipo=1&premioLiquido=${this.premioLiquido}`,
        method: "GET",
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
        }
      })
        .then(response => {
          var blob = new Blob([response.data], { type: "application/pdf" });

          var url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            "Cotação- " + this.proponenteRazaoSocial + ".pdf"
          );
          document.body.appendChild(link);
          link.click();
        })
        .catch(error => {
          this.snackbar.visivel = true;
          this.snackbar.sucesso = false;
          this.snackbar.mensagem = "Pdf Cotação não localizado.";
        })
        .finally((this.dialogDownloadCotacao = false));
    },
    gerarProposta() {
      return axios({
        url:
          `${process.env.URL_APOLICEMS}/v1/gerarProposta/` +
          this.idApolice +
          `?premioLiquido=${this.premioLiquido}`,
        method: "GET",
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
        }
      })
        .then(response => {
          var blob = new Blob([response.data], { type: "application/pdf" });

          var url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            "Proposta- " + this.proponenteRazaoSocial + ".pdf"
          );
          document.body.appendChild(link);
          link.click();
        })
        .catch(error => {
          this.snackbar.visivel = true;
          this.snackbar.sucesso = false;
          this.snackbar.mensagem = "Pdf Proposta não localizado";
        })
        .finally((this.dialogDownloadProposta = false));
    },
    gerarBoleto() {
      return axios({
        url: `${process.env.URL_APOLICEMS}/v1/gerarBoleto/` + this.idApolice,
        method: "GET",
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
        }
      })
        .then(response => {
          var blob = new Blob([response.data], { type: "application/pdf" });

          var url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            "Boleto- " + this.proponenteRazaoSocial + ".pdf"
          );
          document.body.appendChild(link);
          link.click();
        })
        .catch(error => {
          this.snackbar.visivel = true;
          this.snackbar.sucesso = false;
          this.snackbar.mensagem = "Pdf Boleto não localizado";
        });
    },
    gerarApolice() {
      return axios({
        url: `${process.env.URL_APOLICEMS}/v1/gerarApolice/` + this.idApolice,
        method: "GET",
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
        }
      })
        .then(response => {
          var blob = new Blob([response.data], { type: "application/pdf" });

          var url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            "Apolice- " + this.proponenteRazaoSocial + ".pdf"
          );
          document.body.appendChild(link);
          link.click();
        })
        .catch(error => {
          this.snackbar.visivel = true;
          this.snackbar.sucesso = false;
          this.snackbar.mensagem = "Pdf Apólice não localizado";
        });
    },
    toLocalDateTimeString: function(val) {
      var data = CustomFormat.toLocaleDateTimeString(val);
      return data.slice(0, 10);
    },
    formatDate(data) {
      if (data != null) {
        var formatedDate = moment(data).format("DD/MM/YYYY");
        return formatedDate;
      }
    },

    async retornarTipoDeProposta() {
      var response = await axios.get(
        `${process.env.URL_APOLICEMS}/v1/retornarTipoDeProposta/${this.idApolice}`,
        {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
      );
      this.idTipoDeProposta = response.data;
    },

    async retornarTipo() {
      var response = await axios.get(
        `${process.env.URL_APOLICEMS}/v1/retornarTipoDeApolice/${this.idApolice}`,
        {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
      );
      this.idPropostaTipo = response.data;
    },

    async retornarTipoPessoa() {
      var response = await axios.get(
        `${process.env.URL_APOLICEMS}/v1/retornarTipoPessoa/${this.idApolice}`,
        {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
      );
      this.idTipoPessoa = response.data;
    },

    async retornarAplicaCondicao() {
      var response = await axios.get(
        `${process.env.URL_APOLICEMS}/v1/retornarAplicaCondicao/${this.idApolice}`,
        {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
      );
      this.idAplicaCondicao = response.data;
    },

    async retornarTipoCondicao() {
      var response = await axios.get(
        `${process.env.URL_APOLICEMS}/v1/retornarTipoCondicao/${this.idApolice}`,
        {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
      );
      if (response.data == "" || response.data == null) {
        this.preencherCampoTipoCondicao();
      } else {
        this.idTipoCondicao = response.data;
      }
    },

    buscaOpcoes() {
      [
        "propostaStatus",
        "propostaTipo",
        "apoliceTipoDeProposta",
        "apoliceModalidade",
        "parcelamento",
        "formaPagamento",
        "proponenteRamoDeAtuacao",
        "enderecoUf"
      ].forEach(item => {
        axios
          .get(`${process.env.URL_APOLICEMS}/v1/${item}`, {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          })
          .then(response => {
            this[`${item}List`] =
              response.data instanceof Array ? response.data : [];
          })
          .catch(err => {
            console.error(err);
          });
      });
    },

    buscaOpcoesTipoVeiculo() {
      axios
        .get(`${process.env.URL_PLANILHAMS}/v1/buscarOpcoesCampos/`, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`,
          },
        })
        .then((response) => {
          [
            "catVeiculoList",
          ].forEach((nome) => {
            this.modelosListas[nome] =
              response.data[nome] instanceof Array ? response.data[nome] : [];
          });
        })
        .catch((err) => {
          console.error(err);
        });
    },

    adicionarNovaCondicaoComercialEspecial() {
      this.mostrarCamposCondicaoComercialEspecial = true;
      this.listaCondicaoComercialEspecial.push({
        id: null,
        idApolice: null,
        idTipoCondicao: null,
        idAplicaCondicao: null,
        percCondicaoComercial: null,
        listaIdCategoriaVeiculo: []
      })
    },

    removerCondicaoComercialEspecial(index) {
      if (this.listaCondicaoComercialEspecial[index].id !== null) {
        const itemCondicaoComercialEspecialRemovida = this.listaCondicaoComercialEspecial[index];

        this.listaCondicaoComercialEspecial.splice(index, 1);

        if (!this.listaCondicaoComercialEspecialModificacao) {
          this.listaCondicaoComercialEspecialModificacao = [];
        }

        this.listaCondicaoComercialEspecialModificacao.push(itemCondicaoComercialEspecialRemovida);
      } else {
        this.listaCondicaoComercialEspecial.splice(index, 1);
      }
    },

    igualTodosItensCategoriaVeiculo(index) {
      return this.listaCondicaoComercialEspecial[index].listaIdCategoriaVeiculo.length === this.modelosListas.catVeiculoList.length
        || this.listaCondicaoComercialEspecial[index].listaIdCategoriaVeiculo.length > this.modelosListas.catVeiculoList.length;
    },

    igualUmItemCategoriaVeiculo(index) {
      return (
        this.listaCondicaoComercialEspecial[index].listaIdCategoriaVeiculo.length > 0 && !this.igualTodosItensCategoriaVeiculo(index)
      );
    },

    iconeSelecionarTodosCategoriaVeiculo(index) {
      if (this.igualTodosItensCategoriaVeiculo(index)) return "check_box";
      if (this.igualUmItemCategoriaVeiculo(index)) return "indeterminate_check_box";
      return "indeterminate_check_box";
    },

    selecionarTodosItensCategoriaVeiculo(index) {
    	this.$nextTick(() => {
        if (this.igualTodosItensCategoriaVeiculo(index)) {
          this.listaCondicaoComercialEspecial[index].listaIdCategoriaVeiculo = [];
        } else {
          const listagemItensVeiculos = this.modelosListas.catVeiculoList.slice();
          for (var veiculoItem of listagemItensVeiculos) {
            if (!this.listaCondicaoComercialEspecial[index].listaIdCategoriaVeiculo.includes(veiculoItem.id)) {
              this.listaCondicaoComercialEspecial[index].listaIdCategoriaVeiculo.push(veiculoItem.id);
            }
          }
        }
      });
    },

    buscarListaApoliceGrupoUsuario() {
      if (this.idApolice > 0) {
        axios
        .get(`${process.env.URL_APOLICEMS}/v1/buscarGruposUsuarioApolice/${this.idApolice}`, {
          headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
        })
        .then((response) => {
          if (response.data != null && response.data.length > 0) {
            this.gruposIds = response.data;
          }
        });
      }
    },

    buscarListaApoliceCondicaoEspecial() {
      if (this.idApolice > 0) {
        axios
        .get(
          `${process.env.URL_APOLICEMS}/v1/buscarListaApoliceCondicaoEspecial/${this.idApolice}`,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        )
        .then(response => {
          if (response.data != null && response.data.length > 0) {
            this.mostrarCamposCondicaoComercialEspecial = true;
            if (this.$route.query.apoliceCopiada) {
              this.listaCondicaoComercialEspecial = response.data.map(item => {
                const { id, idApolice, ...camposRestantes } = item;
                return camposRestantes;
              });
            } else {
              this.listaCondicaoComercialEspecial = response.data;
            }
          } else {
            this.listaCondicaoComercialEspecial = [];
          }
        })
        .catch(err => {
          console.error(err);
        })
        .finally(() => {
          this.loaderPagina = false;
        });
      }
    },

    voltar: function() {
      this.$router.push("/GridPrincipal");
    },

    onDateChange: function() {
      const self = this;
      const date = self.dateInicio.split("-");
      const ano = parseInt(date[0]) + 1;
      const newDateFim = date.concat(ano + "-" + date[1] + "-" + date[2]);
      this.dateFim = newDateFim[3];
    },

    proximaPagina: function() {
      if (this.cnpjBloqueado) {
        this.mostrarBloqueioCnpj = true;
        return;
      }
      this.verificarListaSuja();
    },

    verificarBloqueioCnpjCpf() {
      if (!this.proponenteCnpj || !this.idTipoPessoa) {
        this.cnpjBloqueado = false;
        return;
      }
      const cpfCnpjValido =
        this.idTipoPessoa === 1
          ? /^\d{11}$/.test(String(this.proponenteCnpj))
          : validadores.validarCNPJ(this.proponenteCnpj);
      if (!cpfCnpjValido) {
        this.cnpjBloqueado = false;
        return;
      }
      axios
        .get(`${process.env.URL_ESSORMS}/v1/bloqueio-cnpjcpf?cpfCnpj=${this.proponenteCnpj}`, {
          headers: { Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}` }
        })
        .then(response => {
          if (response.data && response.data.bloqueado === true) {
            this.motivoBloqueioCnpj = response.data.motivo;
            this.cnpjBloqueado = true;
            this.mostrarBloqueioCnpj = true;
          } else {
            this.cnpjBloqueado = false;
          }
        })
        .catch(err => {
          console.error("Erro ao verificar bloqueio de CPF/CNPJ: ", err);
        });
    },

    async buscarApolice(idApolice) {
      const response = await axios.get(
        `${process.env.URL_APOLICEMS}/v1/visualizarApolice/${idApolice}`,
        {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
      );
      this.$store.commit(
        "formCotacao/setDadosApolice",
        typeof response.data === "string"
          ? JSON.parse(response.data)
          : response.data
      );
      this.idUsuarioCorretorFiltrado = response.data.idUsuarioCorretor;
      this.idTecnicoResponsavelFiltrado = response.data.idTecnicoResponsavel;
      this.idAplicaCondicao = parseInt(response.data.idAplicaCondicao);
      this.statusAtualApolice = response.data.propostaStatus ? response.data.propostaStatus.id : null;
    },
    tipoPessoa() {
      ["tipoPessoa"].forEach(item => {
        axios
          .get(`${process.env.URL_APOLICEMS}/v1/${item}`, {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          })
          .then(response => {
            this[`${item}List`] =
              response.data instanceof Array ? response.data : [];
          })
          .catch(err => {
            console.error(err);
          });
      });
    },

    formatarNumeroCotacao(item) {
      const numero = `000000${item}`;
      return numero.slice(numero.length - 6);
    },
    buscarHistoricoSinistro() {
      this.loaderPagina = true;
      axios
        .get(
          `${process.env.URL_APOLICEMS}/v1/buscarHistorioSinistros/${this.proponenteCnpj}/${this.idApolice}`,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        )
        .then(res => {
          return res.data;
        })
        .then(data => {
          if (data) {
            this.listagemHistoricoSinistro = this.ordenarHistoricosPorInicioDeVigenciaDecrescente(data.historicos)
            this.listagemFrequencia = data.frequenciaLista;
          }
          this.dialogHistorioSinistro = true;
        })
        .catch(err => {
          this.loaderPagina = false;
          this.snackbar.visivel = true;
          this.snackbar.sucesso = false;
          if (err.response.data.message) {
            this.snackbar.mensagem = err.response.data.message;
          } else {
            this.snackbar.mensagem = "Erro ao fazer a busca do cpf ou cnpj";
          }
        })
        .finally(() => {
          this.loaderPagina = false;
        });
    },

    ordenarHistoricosPorInicioDeVigenciaDecrescente(historicos) {
      historicos.forEach(historico => {
        if (historico.detalhes && Array.isArray(historico.detalhes)) {
          historico.detalhes.sort((atualDetalhe, proximoDetalhe) =>  {
            const dateSinistroAtual = new Date(atualDetalhe.dadoSinistro.split('/').reverse().join('-'));
            const dateSinistroProxima = new Date(proximoDetalhe.dadoSinistro.split('/').reverse().join('-'));
            return dateSinistroProxima - dateSinistroAtual;
          });
        }
      });

      historicos.sort((atualHistorico, proximoHistorico) => {
        const dateInicioVigenciaAtual = new Date(atualHistorico.inicioDeVigencia.split('/').reverse().join('-'));
        const dateInicioVigenciaProxima = new Date(proximoHistorico.inicioDeVigencia.split('/').reverse().join('-'));
        return dateInicioVigenciaProxima - dateInicioVigenciaAtual;
      });

      return historicos;
    },

    fecharModalDialogSinistro() {
      (this.listagemHistoricoSinistro = []),
        (this.dialogHistorioSinistro = false);
    },
    salvarCorretorResponsavel(idUsuarioCorretor, nomeUsuarioCorretor) {
      const self = this;
      self.modelCorretorResponsavel.idUsuarioCorretor = idUsuarioCorretor;
      self.modelCorretorResponsavel.nomeUsuarioCorretor = nomeUsuarioCorretor;
      axios.put(`${process.env.URL_APOLICEMS}/v1/atualizarCorretorParceiro/${this.idApolice}`, self.modelCorretorResponsavel, {
          headers: { 'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}` }})
        .then((response) => {
          self.snackbar.sucesso = true;
          self.snackbar.visivel = true;
          self.snackbar.mensagem = 'Corretor responsável vinculado com sucesso';
        })
        .catch((err) => {
          self.snackbar.visivel = true;
          self.snackbar.sucesso = false;
          self.snackbar.mensagem = err.response.data.message;
        })
        this.usuarioResponsavelSet(idUsuarioCorretor, nomeUsuarioCorretor);
    },
    salvarTecnicoResponsavel(idTecnicoResponsavel, nomeTecnicoResponsavel) {
      const self = this;
      self.modelTecnicoResponsavel.idTecnicoResponsavel = idTecnicoResponsavel;
      self.modelTecnicoResponsavel.nomeTecnicoResponsavel = nomeTecnicoResponsavel;
      axios.put(`${process.env.URL_APOLICEMS}/v1/atualizarTecnicoResponsavel/${this.idApolice}`, self.modelTecnicoResponsavel, {
          headers: { 'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}` }})
        .then((response) => {
          self.snackbar.sucesso = true;
          self.snackbar.visivel = true;
          self.snackbar.mensagem = 'Tecnico responsável da apólice vinculado com sucesso';
        })
        .catch((err) => {
          self.snackbar.visivel = true;
          self.snackbar.sucesso = false;
          self.snackbar.mensagem = err.response.data.message;
        })
      this.tecnicoResponsavelSet(idTecnicoResponsavel, nomeTecnicoResponsavel);
    }
  }
};
</script>

<style scoped>
.button-message {
  text-transform: capitalize;
  font-weight: 400;
  font-size: 12px;
}

.button-custom {
  width: 100%;
  max-width: 121px;
  text-align: center;
  color: #fff;
  background-color: #00456e;
  border-radius: 2px;
  display: inline-block;
  padding: 9px 12px;
  cursor: pointer;

  font-weight: bold;
}

.button-vinculo {
  width: 100%;
  max-width: 150px;
  text-align: center;
  color: #fff !important;
  background-color: #00456e;
  border-radius: 2px;
  display: inline-block;
  padding: 9px 12px;
  cursor: pointer;
  font-weight: bold;
}

.InfoGerais .v-autocomplete__content {
  top: 312px !important;
}

.headline {
  color: #fff;
  font-size: 25px !important;
}

.btn-download-pdf {
  border: 0;
  background-color: transparent;
  text-align: center;
  color: #027db4;
  box-shadow: none;
}
.btn-download-pdf:hover {
  text-decoration: underline;
}
.wrapper-radio-social {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}

.btn-remover-condicao-especial {
  color: #00456e;
  border: 2px solid #00466E;
  transition: 0.2s all;
}
.btn-remover-condicao-especial:hover {
  background-color: #A3C4D2;

}
</style>



// WEBPACK FOOTER //
// src/components/pages/frota/InfoGerais.vue